// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const mcpConsentInRequestMax = 4096;

export const mcpConsentInScopesOneItemMax = 60;

export const mcpConsentInScopesOneMax = 20;

export const McpConsentIn = zod.object({
  "allow": zod.boolean(),
  "request": zod.string().min(1).max(mcpConsentInRequestMax),
  "scopes": zod.union([zod.array(zod.string().max(mcpConsentInScopesOneItemMax)).max(mcpConsentInScopesOneMax),zod.null()]).optional()
});

export type McpConsentIn = zod.input<typeof McpConsentIn>;
export type McpConsentInOutput = zod.output<typeof McpConsentIn>;
